import {ExcTranslation} from 'exc-core-v2';
import {TableRow} from './Interfaces/TableRow.interface';
import {ObjectList} from './Interfaces/ObjectList.interface';

export default class ToolboxDataStore extends ExcTranslation {

  constructor() {
    super();
  }

  getToolBoxData(): any[] {
    return [
      {
        quest_enmIdent_questType: 1,
        counter: 0,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 0,
        name: this.getRessource('Chapter'),
        questText: '',
        questHelp: '',
        questIsOptional: false,
        questScore: null,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-bars',
        tooltip: 'Chapter',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: -1,
        counter: 0,
        quest_Ident: 0,
        questIdentation: 1,
        quest_enmIdent_questValueFormat: 0,
        name: this.getRessource('SubChapter'),
        questText: '',
        questHelp: '',
        questIsOptional: false,
        questScore: null,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-list-tree',
        tooltip: 'SubChapter',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        counter: 0,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 1,
        name: this.getRessource('YesOrNo'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-list-ol',
        tooltip: 'YesOrNo',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        counter: 0,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 2,
        name: this.getRessource('SingleChoice'), questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-list-radio',
        tooltip: 'SingleChoice',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        counter: 0,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 3,
        name: this.getRessource('MultipleChoice'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-list-check',
        tooltip: 'MultipleChoice',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 3,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 0,
        name: this.getRessource('Option'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-circle-dot',
        tooltip: 'Option',
        followUpType: 0,
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: null,
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 4,
        name: this.getRessource('UploadDocuments'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-upload',
        tooltip: 'UploadDocuments',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 5,
        name: this.getRessource('UploadPictures'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-image',
        tooltip: 'UploadPictures',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 2,
        quest_enmIdent_questValueFormat: 7,
        name: this.getRessource('SingleLineText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-input-text',
        tooltip: 'SingleLineText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 8,
        name: this.getRessource('MultipleLineText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-message',
        tooltip: 'MultipleLineText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 9,
        name: this.getRessource('NumberText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-binary',
        tooltip: 'NumberText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 10,
        name: this.getRessource('DecimalnumberText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-4',
        tooltip: 'DecimalnumberText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 11,
        name: this.getRessource('PercentageText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-percent',
        tooltip: 'PercentageText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 12,
        name: this.getRessource('CurrencyText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-euro-sign',
        tooltip: 'CurrencyText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 13,
        name: this.getRessource('DateText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-calendar',
        tooltip: 'DateText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 14,
        name: this.getRessource('TimeText'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-timer',
        tooltip: 'TimeText',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 15,
        name: this.getRessource('Rating'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-star-sharp-half-stroke',
        tooltip: 'Rating',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      },
      {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 16,
        name: this.getRessource('MultipleAnswer'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-tags',
        tooltip: 'MultipleAnswer',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      }
      , {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 17,
        name: this.getRessource('2DTable'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-table',
        tooltip: '2DTable',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questConfiguration: this.getFirstConfig(),
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        configs: JSON.parse(this.getFirstConfig())
      }
      , {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 18,
        name: this.getRessource('CustomForm'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-file-code',
        tooltip: 'CustomForm',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: ''
      }
      , {
        quest_enmIdent_questType: 2,
        quest_Ident: 0,
        questIdentation: 0,
        quest_enmIdent_questValueFormat: 19,
        name: this.getRessource('ObjectList'),
        questText: '',
        questHelp: '',
        questScore: null,
        questIsOptional: false,
        questFollowUp: '',
        questFollowUpDays: null,
        questFollowUpFixD: null,
        quest_kidID: null,
        quest_segID: null,
        questFollowUpShortText: null,
        questCondition: null,
        questCondition_questID: null,
        questConditional: null,
        questID: null,
        icon: 'fa-table-list',
        tooltip: 'ObjectList',
        questIsKO: false,
        questIsInapplicable: false,
        questPreText: null,
        questLink: null,
        questLinkText: this.getRessource('LinkText'),
        questHexCode: null,
        questAlias: null,
        questConfiguration: this.getInitialObjectList()
      }
    ];
  }

  getFirstConfig(): string {
    const config: TableRow[] = [
      {
        x: this.getRessource('Row') + ' 1', cols: [{y: this.getRessource('Col') + ' 1', score: 0},
          {y: this.getRessource('Col') + ' 2', score: 0},
          {y: this.getRessource('Col') + ' 3', score: 0}]
      },
      {
        x: this.getRessource('Row') + ' 2', cols: [{y: this.getRessource('Col') + ' 1', score: 0},
          {y: this.getRessource('Col') + ' 2', score: 0},
          {y: this.getRessource('Col') + ' 3', score: 0}]
      }
    ];
    return JSON.stringify(config);
  }

  getInitialObjectList(): string {
    const objList: ObjectList = {
      Headers: [
        'Input'
      ],
      Types: [
        'text'
      ],
      Template: [
        ''
      ],
      Required: [
        false
      ],
      MinRow: 1,
      MaxRow: -1
    };
    return JSON.stringify(objList);
  }
}
